/**
 * Einstiegspunkt der 3-Topf vs. 1-Topf Portfolio Monte-Carlo Simulation Anwendung
 * Initialisiert React und rendert die Hauptkomponente
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalyticsConsentDefaults } from './utils/analytics';

// Cloudscape Design System Styles
import '@cloudscape-design/global-styles/index.css';

// Removed Amplify Authentication - using API Key authentication instead

// Consent Mode v2: Default vor React-Render und vor gtag.js (GA4 / EU)
initAnalyticsConsentDefaults();

/**
 * Rendert die Anwendung in das DOM
 */
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
